module.exports = __webpack_public_path__ + "media/images/regional-image11-8ab3e9ca9be1dccb1c0b0152928e6655.jpg";